module.exports = __webpack_public_path__ + "img/ro-rise-smarthome-img.8824beea.jpg";